import React, { Fragment, useEffect, useState } from "react";
import {
  Typography,
  Box,
  Table,
  AspectRatio,
  Divider,
  ButtonGroup,
  Button,
  Sheet,
  Modal,
  ModalOverflow,
  ModalDialog,
  ModalClose,
  DialogTitle,
  DialogContent,
  Stack,
  FormControl,
  FormLabel,
  Input,
  Select,
  Option,
} from "@mui/joy";
import { toast } from "react-toastify";
import { LoadingView, MapContainer, PageTitle } from "../../../components";
import { useLocation, useNavigate } from "react-router-dom";
import { FILE_BASE, STATUS } from "../../../constant";
import { connect, useDispatch } from "react-redux";
import {
  deactivatePartnerRequest,
  activatePartnerRequest,
  deactivatePartnerReset,
  activatePartnerReset,
  viewPartnerReset,
  viewPartnerRequest,
  rejectPartnerRequest,
  rejectPartnerReset,
  approvePartnerRequest,
  approvePartnerReset,
  editPartnerRequest,
  editPartnerReset,
} from "../../../store/actions";
import {
  BlockOutlined,
  CheckCircle,
  DoNotDisturbOn,
  EditOutlined,
  FolderOpenOutlined,
  LocationOn,
  PriceChangeOutlined,
  RemoveRedEyeOutlined,
  TaskAltOutlined,
} from "@mui/icons-material";
import {
  NAVIGATE_TO_PARTNERAGENTS,
  NAVIGATE_TO_STAFFPAGE,
  NAVIGATE_TO_TARRIFPAGE,
} from "../../../route/types";
import locations from "../../../assets/locations.json";
import UploadPhotoForm from "./UploadPhotoForm";

function CreateItems(title: String, value: String) {
  return { title, value };
}

const PartnerViewPage = ({
  loginResult,

  editPartnerStatus,
  editPartnerResult,
  editPartnerErrorMessage,

  viewPartnerStatus,
  viewPartnerResult,
  viewPartnerErrorMessage,

  rejectPartnerStatus,
  rejectPartnerResult,
  rejectPartnerErrorMessage,

  approvePartnerStatus,
  approvePartnerResult,
  approvePartnerErrorMessage,

  activatePartnerStatus,
  activatePartnerResult,
  activatePartnerErrorMessage,

  deactivatePartnerStatus,
  deactivatePartnerResult,
  deactivatePartnerErrorMessage,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { partner_id } = state;

  const [formModal, setFormModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const [approvalModal, setApprovalModal] = useState(false);
  const [deactivateModal, setDeactivateModal] = useState(false);

  const [name, setName] = useState("");
  const [partner_type, setPartnerType] = useState("");
  const [location, setLocation] = useState({
    latitude: 0,
    longitude: 0,
  });
  const [nearest, setNearest] = useState("");
  const [ward, setWard] = useState("");
  const [street, setStreet] = useState("");
  const [other, setOther] = useState("");
  const [post_code, setPostCode] = useState("");
  const [zip_code, setZipCode] = useState("");
  const [status, setStatus] = useState(0);
  const [remark, setRemark] = useState("");
  const [rejectReason, setRejectReason] = useState("");
  // const [mobile, setMobile] = useState('');
  const [email, setEmail] = useState("");

  const [regionList, setRegionList] = useState([]);
  const [region, setRegion] = useState("");
  const [districtList, setDistrictList] = useState([]);
  const [district, setDistrict] = useState("");
  const [photo, setPhoto] = useState("");
  const [id, setId] = useState("");
  const [uploadPhotoModal, setUploadModal] = useState(false);
  const [fspCode, setFspCode] = useState("");
  const [approvalFspCode, setApprovalFspCode] = useState("");

  const [attachments, setAttachments] = useState([
    {
      attachment_name: "",
      attachment_value: "",
      file: null,
      url: "",
    },
  ]);

  useEffect(() => {
    if (viewPartnerStatus === STATUS.SUCCESS) {
      setName(viewPartnerResult.partnerData.name);
      setEmail(viewPartnerResult.partnerData.email);
      setDistrict(viewPartnerResult.partnerData.address.district);
      setLocation({
        latitude: viewPartnerResult.partnerData.address.latitude,
        longitude: viewPartnerResult.partnerData.address.longitude,
      });
      setWard(viewPartnerResult.partnerData.address.ward);
      setStreet(viewPartnerResult.partnerData.address.street);
      setRegion(viewPartnerResult.partnerData.address.region);
      setPostCode(viewPartnerResult.partnerData.address.post_code);
      setNearest(viewPartnerResult.partnerData.address.nearest_landmark);
      setStatus(viewPartnerResult.partnerData.status);
      setOther(viewPartnerResult.partnerData.address.other_details);
      setZipCode(viewPartnerResult.partnerData.address.zip_code);
      setPartnerType(viewPartnerResult.partnerData.partner_type.toString());
      setRemark(viewPartnerResult.partnerData.remark);
      setPhoto(viewPartnerResult.partnerData.photo);
      setId(viewPartnerResult.partnerData.id);
      setFspCode(viewPartnerResult.partnerData.fspCode);
      setAttachments(
        viewPartnerResult.attachments.map((item, index) => ({
          attachment_name: item.attachment_name,
          attachment_value: item.attachment_value,
          file: null,
          url: FILE_BASE + "/auth/attachments/" + item.file_path,
        })),
      );
      // setTimeout(() => {
      //   dispatch(viewPartnerReset());
      // }, 2000);
    } else if (viewPartnerStatus === STATUS.ERROR) {
      toast.error(viewPartnerErrorMessage);
      dispatch(viewPartnerReset());
    }

    if (editPartnerStatus === STATUS.SUCCESS) {
      toast.success("Partner edited successful");
      setFormModal(false);
      dispatch(viewPartnerRequest(loginResult.token, { id: partner_id }));
      dispatch(editPartnerReset());
    } else if (editPartnerStatus === STATUS.ERROR) {
      toast.error(editPartnerErrorMessage);
      dispatch(editPartnerReset());
    }

    if (approvePartnerStatus === STATUS.SUCCESS) {
      toast.success("Partner approved successful");
      dispatch(viewPartnerRequest(loginResult.token, { id: partner_id }));
      dispatch(approvePartnerReset());
      setApprovalModal(false);
    } else if (approvePartnerStatus === STATUS.ERROR) {
      toast.error(approvePartnerErrorMessage);
      dispatch(approvePartnerReset());
      setApprovalModal(false);
    }

    if (rejectPartnerStatus === STATUS.SUCCESS) {
      toast.success("Partner rejected successful");
      dispatch(viewPartnerRequest(loginResult.token, { id: partner_id }));
      setRejectModal(false);
      dispatch(rejectPartnerReset());
    } else if (rejectPartnerStatus === STATUS.ERROR) {
      toast.error(rejectPartnerErrorMessage);
      dispatch(rejectPartnerReset());
    }

    if (activatePartnerStatus === STATUS.SUCCESS) {
      toast.success("Partner activated successful");
      dispatch(viewPartnerRequest(loginResult.token, { id: partner_id }));
      dispatch(activatePartnerReset());
    } else if (activatePartnerStatus === STATUS.ERROR) {
      toast.error(activatePartnerErrorMessage);
      dispatch(activatePartnerReset());
    }

    if (deactivatePartnerStatus === STATUS.SUCCESS) {
      toast.success("Partner deactivated successful");
      setDeactivateModal(false);
      dispatch(viewPartnerRequest(loginResult.token, { id: partner_id }));
      dispatch(deactivatePartnerReset());
    } else if (activatePartnerStatus === STATUS.ERROR) {
      toast.error(deactivatePartnerErrorMessage);
      dispatch(deactivatePartnerReset());
    }
  });

  useEffect(() => {
    if (partner_id != "") {
      dispatch(viewPartnerRequest(loginResult.token, { id: partner_id }));
    }
  }, []);

  /* --------------- location (region and district data) ----------- */

  useEffect(() => {
    let _regions = [];
    locations.map((val) => {
      _regions.push(val.name);
    });
    setRegionList(_regions);
  }, []);

  useEffect(() => {
    //first clear selected district
    // setDistrict('')
    locations.find((location) => {
      //return location.name = region
      let _districtList = [];
      if (location.name == region) {
        location.districts.map((val) => {
          _districtList.push(val.name);
        });
        setDistrictList(_districtList);
        return;
      }
    });
  }, [region]);

  const handleRegion = (event, newValue) => {
    setRegion(newValue);
  };

  const handleDistrict = (event, newValue) => {
    setDistrict(newValue);
  };

  const submitEditForm = (event) => {
    event.preventDefault();
    if (name && street && ward && partner_type && region && district) {
      const formData = new FormData();

      // Append non-file data
      formData.append("id", partner_id);
      formData.append("street", street);
      formData.append("ward", ward);
      formData.append("district", district);
      formData.append("region", region);
      formData.append("zip_code", zip_code);
      formData.append("post_code", post_code);
      formData.append("latitude", location.latitude.toString());
      formData.append("longitude", location.longitude.toString());
      formData.append("nearest_landmark", nearest);
      formData.append("other_details", other);
      formData.append("partner_name", name);
      formData.append("partner_type", partner_type);
      formData.append("email", email);
      // attachments.forEach((item, index) => {
      //     formData.append(`attachments[${index}][file]`, item.file);
      //     formData.append(`attachments[${index}][attachment_name]`, item.attachment_name);
      //     formData.append(`attachments[${index}][attachment_value]`, item.attachment_value);
      // });

      dispatch(editPartnerRequest(loginResult.token, formData));
    } else {
      toast.error("Please fill all required information");
    }
  };

  // FUNCTION TO GET LOCATION
  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (error) => {
          console.error("Error getting location:", error.message);
          // alert(`geolocation Error: ${JSON.stringify(error)}`)
          // toast.error(`geolocation Error: ${error.message}`)
        },
      );
    } else {
      alert(
        "Geolocation is not supported with this browser, please use another browser for completion",
      );
    }
  };

  // FUNCTION TO ADD, REMOVE AND HANDLE COLLATERAL INPUTS
  const addAttachmentsData = () => {
    setAttachments([
      ...attachments,
      {
        attachment_name: "",
        attachment_value: "",
        file: null,
        url: "",
      },
    ]);
  };

  const removeAttachmentsData = (index) => {
    const updateData = [...attachments];
    updateData.splice(index, 1);
    setAttachments(updateData);
  };

  const handleAttachmentsChange = (index, field, text) => {
    const updatedFields = [...attachments];
    updatedFields[index][field] = text;
    setAttachments(updatedFields);
  };

  // FUNCTION TO GET PICTURE
  const handlePicture = (event, index) => {
    console.log("Picture pros: ", event.target.files);
    const updatedFields = [...attachments];
    updatedFields[index]["file"] = event.target.files[0];
    updatedFields[index]["url"] = URL.createObjectURL(event.target.files[0]);
    setAttachments(updatedFields);
  };

  const handlePartnerAdd = (event, newValue) => {
    setPartnerType(newValue);
  };

  // ------ actions -------------------------
  const approvePartner = (e) => {
    e.preventDefault();

    const data = {
      id: partner_id,
      fsp_code: approvalFspCode,
    };
    dispatch(approvePartnerRequest(loginResult.token, data));
  };

  const rejectPartner = (event) => {
    event.preventDefault();
    const data = {
      id: partner_id,
      remark: rejectReason,
    };
    dispatch(rejectPartnerRequest(loginResult.token, data));
  };

  const activatePartner = () => {
    const data = {
      id: partner_id,
    };
    dispatch(activatePartnerRequest(loginResult.token, data));
  };

  const deactivatePartner = (event) => {
    event.preventDefault();
    const data = {
      id: partner_id,
      remark: remark,
    };
    dispatch(deactivatePartnerRequest(loginResult.token, data));
  };

  const goToStaff = () => {
    navigate(NAVIGATE_TO_STAFFPAGE, {
      state: {
        partner_id: partner_id,
      },
    });
  };

  const goToAgents = () => {
    navigate(NAVIGATE_TO_PARTNERAGENTS, {
      state: {
        partner_id: partner_id,
      },
    });
  };

  const goToTarrifs = () => {
    navigate(NAVIGATE_TO_TARRIFPAGE, {
      state: {
        partner_id: partner_id,
        partner_name: name,
        fsp_code: fspCode,
      },
    });
  };

  const handleUploadPhoto = () => {
    setUploadModal(true);
  };

  const checkLoading = () => {
    if (
      viewPartnerStatus === STATUS.LOADING ||
      editPartnerStatus === STATUS.LOADING ||
      approvePartnerStatus === STATUS.LOADING ||
      rejectPartnerStatus === STATUS.LOADING ||
      activatePartnerStatus === STATUS.LOADING ||
      deactivatePartnerStatus === STATUS.LOADING
    ) {
      return true;
    } else {
      return false;
    }
  };

  const rows = [
    CreateItems("Name", name),
    CreateItems(
      "Partner",
      {
        1: "Admin (T-bridge Technologies)",
        2: "Bank",
        3: "Mobile Service Providers",
      }[partner_type],
    ),
    CreateItems("Email", email),
    CreateItems(
      "Status",
      { 1: "Active", 2: "Inactive", 3: "Pending", 4: "Rejected" }[status],
    ),
    CreateItems("Region", region),
    CreateItems("District", district),
    CreateItems("Ward", ward),
    CreateItems("Street", street),
    CreateItems("Post Code", post_code),
    CreateItems("Zip Code", zip_code),
    CreateItems("Nearest landmark", nearest),
    CreateItems("Other Details", other),
    CreateItems("Remark", remark),
    CreateItems("Fsp Code", fspCode),
  ];

  return (
    <Box>
      <PageTitle title={`${name} Details`} />

      <LoadingView loading={checkLoading()} />

      {/* Contents */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
        {/* Action Button */}
        <Box
          sx={{
            display: "flex",
            gap: 2,
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          {/* ------ only admin can do this actions ------ */}
          {loginResult.role === 1 &&
            status != 4 &&
            (status === 3 ? (
              <>
                <Button
                  color="success"
                  startDecorator={<TaskAltOutlined />}
                  onClick={() => setApprovalModal(true)}
                >
                  Approve
                </Button>
                <Button
                  color="warning"
                  startDecorator={<BlockOutlined />}
                  onClick={() => setRejectModal(true)}
                >
                  Reject
                </Button>
              </>
            ) : status === 1 ? (
              <>
                <Button
                  color="danger"
                  startDecorator={<DoNotDisturbOn />}
                  onClick={() => setDeactivateModal(true)}
                >
                  Deactivate
                </Button>

                <Button
                  color="primary"
                  startDecorator={<EditOutlined />}
                  onClick={() => setFormModal(true)}
                >
                  Edit
                </Button>
              </>
            ) : (
              <Button
                color="success"
                startDecorator={<CheckCircle />}
                onClick={activatePartner}
              >
                Activate
              </Button>
            ))}

          <Button
            color="neutral"
            startDecorator={<RemoveRedEyeOutlined />}
            onClick={goToStaff}
          >
            View Staff
          </Button>

          <Button
            color="neutral"
            // startDecorator={<RemoveRedEyeOutlined />}
            onClick={goToAgents}
          >
            View Agents
          </Button>

          <Button
            color="primary"
            startDecorator={<PriceChangeOutlined />}
            onClick={goToTarrifs}
          >
            View Tarrifs
          </Button>

          {!photo && (
            <Button color="warning" onClick={handleUploadPhoto}>
              Upload Photo
            </Button>
          )}
        </Box>

        {/* Details */}
        <Box
          sx={{
            gap: 2,
            display: "flex",
            flexDirection: "column",
            width: { xs: "unset", md: "70%" },
          }}
        >
          {/* client details */}
          <Sheet
            className="OrderTableContainer"
            variant="outlined"
            sx={{
              display: "flex",
              // width: '100%',
              borderRadius: "sm",
              flexShrink: 1,
              overflow: "auto",
              minHeight: 0,
            }}
          >
            <Table
              // aria-label="striped table"
              // stripe="odd"
              // variant="soft"
              aria-labelledby="tableTitle"
              stickyHeader
              hoverRow
              sx={{
                "--TableCell-headBackground":
                  "var(--joy-palette-background-level2)",
                "--Table-headerUnderlineThickness": "1px",
                "--TableRow-hoverBackground":
                  "var(--joy-palette-background-level1)",
                "--TableCell-paddingY": "4px",
                "--TableCell-paddingX": "8px",
              }}
            >
              <thead>
                <tr>
                  <th style={{ width: "40%", fontSize: 18 }}>
                    Partner Details
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => (
                  <tr key={index}>
                    <td>
                      <b>{row.title}</b>
                    </td>
                    <td>{row.value}</td>
                  </tr>
                ))}
                <tr>
                  {/* <td><b>Map Location</b></td> */}
                  <td>
                    <AspectRatio
                      variant="outlined"
                      ratio="1"
                      sx={{ width: "150", borderRadius: 4 }}
                    >
                      <MapContainer
                        latitude={location.latitude}
                        longitude={location.longitude}
                      />
                    </AspectRatio>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Sheet>

          {/* Attachments */}
          <Sheet
            className="OrderTableContainer"
            variant="outlined"
            sx={{
              display: "flex",
              // width: '100%',
              borderRadius: "sm",
              flexShrink: 1,
              overflow: "auto",
              minHeight: 0,
            }}
          >
            <Table
              // aria-label="striped table"
              // stripe="odd"
              // variant="soft"
              aria-labelledby="tableTitle"
              stickyHeader
              hoverRow
              sx={{
                "--TableCell-headBackground":
                  "var(--joy-palette-background-level2)",
                "--Table-headerUnderlineThickness": "1px",
                "--TableRow-hoverBackground":
                  "var(--joy-palette-background-level1)",
                "--TableCell-paddingY": "4px",
                "--TableCell-paddingX": "8px",
              }}
            >
              <thead>
                <tr>
                  <th style={{ width: "40%", fontSize: 18 }}>Attachments</th>
                  <th></th>
                </tr>
              </thead>
              {attachments.map((item, index) => (
                <tbody key={index}>
                  <tr>
                    <td>
                      <b>Attachment Name</b>
                    </td>
                    <td>{item.attachment_name}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>Attachment Value</b>
                    </td>
                    <td>Tsh. {item.attachment_value}</td>
                  </tr>
                  <tr>
                    {/* <td>
                                    <Typography><b>Attachment File</b></Typography>

                                </td> */}
                    <td>
                      <AspectRatio
                        variant="outlined"
                        ratio="1"
                        sx={{ width: "150", borderRadius: 4 }}
                      >
                        <img src={item.url} loading="lazy" alt="" />
                      </AspectRatio>
                    </td>
                  </tr>
                  <tr style={{ height: "15px" }}></tr>
                </tbody>
              ))}
            </Table>
          </Sheet>
          {/* Photo */}
          <Sheet
            className="OrderTableContainer"
            variant="outlined"
            sx={{
              display: "flex",
              // width: '100%',
              borderRadius: "sm",
              flexShrink: 1,
              overflow: "auto",
              minHeight: 0,
            }}
          >
            <Table
              // aria-label="striped table"
              // stripe="odd"
              // variant="soft"
              aria-labelledby="tableTitle"
              stickyHeader
              hoverRow
              sx={{
                "--TableCell-headBackground":
                  "var(--joy-palette-background-level2)",
                "--Table-headerUnderlineThickness": "1px",
                "--TableRow-hoverBackground":
                  "var(--joy-palette-background-level1)",
                "--TableCell-paddingY": "4px",
                "--TableCell-paddingX": "8px",
              }}
            >
              <thead>
                <tr>
                  <th style={{ width: "40%", fontSize: 18 }}>Photo</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <AspectRatio
                      variant="outlined"
                      ratio="1"
                      sx={{ width: "150", borderRadius: 4 }}
                    >
                      <img
                        src={`data:image/jpeg;base64,${photo}`}
                        loading="lazy"
                        alt=""
                      />
                    </AspectRatio>
                  </td>
                </tr>
                <tr style={{ height: "15px" }}></tr>
              </tbody>
            </Table>
          </Sheet>
        </Box>
      </Box>

      {/* ------ Modal form for edit Partner details ------ */}
      <Modal open={formModal}>
        <ModalOverflow sx={{ pt: "70px" }}>
          <ModalDialog
            aria-labelledby="nested-modal-title"
            aria-describedby="nested-modal-description"
            // aria-labelledby="modal-dialog-overflow"
            // layout="fullscreen"
            sx={(theme) => ({
              // pt: '600px',
              minWidth: { xs: "unset", md: "800px" },
              [theme.breakpoints.only("xs")]: {
                top: "60px",
                bottom: 0,
                left: 0,
                right: 0,
                // borderRadius: 0,
                borderTopLeftRadius: 20,
                borderTopRightRadius: 20,
                transform: "none",
                maxWidth: "unset",
                overflow: "auto",
              },
            })}
          >
            <ModalClose
              variant="outlined"
              onClick={() => setFormModal(false)}
            />
            <DialogTitle>{`Edit ${name} Details`}</DialogTitle>
            <DialogContent>Please enter Partner details correct.</DialogContent>
            <Stack
              component="form"
              onSubmit={submitEditForm}
              gap={2}
              sx={{ mt: 2 }}
            >
              <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                {/* name */}
                <FormControl sx={{ flex: 1 }} required>
                  <FormLabel>Partner Name</FormLabel>
                  <Input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Enter agent name"
                  />
                </FormControl>

                {/* partner type */}
                <FormControl sx={{ flex: 1 }} required>
                  <FormLabel>Partner Type</FormLabel>
                  <Select
                    placeholder="Select partner type"
                    value={partner_type}
                    onChange={handlePartnerAdd}
                    required
                  >
                    <Option value="1">Admin (T-bridge Technologies)</Option>
                    <Option value="2">Bank</Option>
                    <Option value="3">Mobile Service Providers</Option>
                  </Select>
                </FormControl>
              </Stack>

              <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                {/* email */}
                <FormControl sx={{ flex: 1 }} required>
                  <FormLabel>Email</FormLabel>
                  <Input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter partner email"
                  />
                </FormControl>
              </Stack>

              <Typography level="title-md">Address</Typography>
              <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                {/* region */}
                <FormControl sx={{ flex: 1 }} required>
                  <FormLabel>Region</FormLabel>
                  <Select
                    placeholder="Select region"
                    value={region}
                    onChange={handleRegion}
                    required
                  >
                    {regionList.map((dt) => (
                      <Option value={dt}>{dt}</Option>
                    ))}
                  </Select>
                </FormControl>

                {/* district */}
                {region && (
                  <FormControl sx={{ flex: 1 }} required>
                    <FormLabel>District</FormLabel>
                    <Select
                      placeholder="Select district"
                      value={district}
                      onChange={handleDistrict}
                      required
                    >
                      {districtList.map((dt) => (
                        <Option value={dt}>{dt}</Option>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </Stack>

              <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                {/* Ward */}
                <FormControl sx={{ flex: 1 }} required>
                  <FormLabel>Ward</FormLabel>
                  <Input
                    type="text"
                    value={ward}
                    onChange={(e) => setWard(e.target.value)}
                    placeholder="Enter ward"
                  />
                </FormControl>

                {/* street */}
                <FormControl sx={{ flex: 1 }} required>
                  <FormLabel>Street</FormLabel>
                  <Input
                    type="text"
                    value={street}
                    onChange={(e) => setStreet(e.target.value)}
                    placeholder="Enter street"
                  />
                </FormControl>
              </Stack>

              <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                {/* post code */}
                <FormControl required sx={{ flex: 1 }}>
                  <FormLabel>Post code</FormLabel>
                  <Input
                    type="text"
                    value={post_code}
                    onChange={(e) => setPostCode(e.target.value)}
                    placeholder="Enter post code"
                  />
                </FormControl>

                {/* zip code */}
                <FormControl required sx={{ flex: 1 }}>
                  <FormLabel>Zip Code</FormLabel>
                  <Input
                    type="text"
                    value={zip_code}
                    onChange={(e) => setZipCode(e.target.value)}
                    placeholder="Enter zip code"
                  />
                </FormControl>

                {/* nearest land mark */}
                <FormControl required sx={{ flex: 1 }}>
                  <FormLabel>Nearest land mark</FormLabel>
                  <Input
                    type="text"
                    value={nearest}
                    onChange={(e) => setNearest(e.target.value)}
                    placeholder="Enter nearest landmark"
                  />
                </FormControl>
              </Stack>

              <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                {/* map */}
                {location.latitude != 0 && (
                  <Box>
                    <Typography level="title-sm">
                      * Point your location on map
                    </Typography>
                    <AspectRatio
                      variant="outlined"
                      ratio="1"
                      sx={{ width: 300, borderRadius: 4 }}
                    >
                      <MapContainer
                        latitude={location.latitude}
                        longitude={location.longitude}
                        setLocation={setLocation}
                      />
                    </AspectRatio>
                  </Box>
                )}
                {/* location coordinates */}
                <FormControl sx={{ flex: 1 }}>
                  <FormLabel>Location</FormLabel>
                  <Input
                    readOnly
                    placeholder={
                      location.latitude == 0
                        ? "<--- Click to open map"
                        : `lat: ${location.latitude} long: ${location.longitude}`
                    }
                    // value={location.latitude}
                    startDecorator={
                      <Button
                        variant="soft"
                        color="neutral"
                        startDecorator={<LocationOn />}
                        onClick={getLocation}
                      >
                        {location.latitude === 0
                          ? "Open map"
                          : "Current location"}
                      </Button>
                    }
                  />
                </FormControl>
              </Stack>

              {/* attachments */}
              <Typography level="title-md">Attachments</Typography>
              {attachments.map((field, index) => (
                <Box
                  key={index}
                  sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                >
                  <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                    <FormControl sx={{ flex: 1 }} required>
                      <FormLabel>Attachment Name</FormLabel>
                      <Input
                        type="text"
                        value={field.attachment_name}
                        onChange={(event) =>
                          handleAttachmentsChange(
                            index,
                            "attachment_name",
                            event.target.value,
                          )
                        }
                        placeholder="Enter attachment name"
                        required
                      />
                    </FormControl>
                    <FormControl sx={{ flex: 1 }} required>
                      <FormLabel>Value</FormLabel>
                      <Input
                        type="text"
                        value={field.attachment_value}
                        onChange={(event) =>
                          handleAttachmentsChange(
                            index,
                            "attachment_value",
                            event.target.value,
                          )
                        }
                        // slotProps={{input: {component: NumericFormatAdapter}}}
                        // startDecorator={"Tsh."}
                        required
                      />
                    </FormControl>
                  </Stack>

                  <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                    <FormControl sx={{ flex: 1 }}>
                      <FormLabel>Attachment file</FormLabel>
                      <input
                        type="file"
                        id={`col-picture${index}`}
                        hidden
                        onChange={(event) => handlePicture(event, index)}
                      />

                      <Input
                        type="file"
                        startDecorator={
                          <Button
                            variant="soft"
                            color="neutral"
                            startDecorator={<FolderOpenOutlined />}
                          >
                            <label htmlFor={`col-picture${index}`}>
                              Choose File
                            </label>
                          </Button>
                        }
                        sx={{
                          // Define internal styles for the file input
                          '& input[type="file"]::file-selector-button': {
                            display: "none",
                          },
                        }}
                        onChange={(event) => handlePicture(event, index)}
                      />
                    </FormControl>

                    {field.url != "" && (
                      <AspectRatio
                        variant="outlined"
                        ratio="1"
                        sx={{ width: 150, borderRadius: 4 }}
                      >
                        <img src={field.url} loading="lazy" alt="" />
                      </AspectRatio>
                    )}
                  </Stack>

                  <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                    <ButtonGroup sx={{ mt: 1 }}>
                      {field.url != null && (
                        <Button
                          onClick={addAttachmentsData}
                          variant="solid"
                          color="primary"
                        >
                          + Add
                        </Button>
                      )}
                      {attachments.length > 1 && (
                        <Button
                          onClick={() => removeAttachmentsData(index)}
                          variant="solid"
                          color="danger"
                        >
                          - Remove
                        </Button>
                      )}
                    </ButtonGroup>

                    <Divider sx={{ my: 2 }} />
                  </Stack>
                </Box>
              ))}

              {/* other info */}
              <FormControl sx={{ flex: 1 }}>
                <FormLabel>Other Details</FormLabel>
                <Input
                  type="text"
                  value={other}
                  onChange={(e) => setOther(e.target.value)}
                  placeholder="Enter other details if available"
                />
              </FormControl>

              <Stack gap={4} sx={{ mt: 2 }}>
                <Button type="submit" fullWidth>
                  Submit
                </Button>
              </Stack>
            </Stack>
          </ModalDialog>
        </ModalOverflow>
      </Modal>

      {/* reject modal */}
      <Modal open={rejectModal}>
        <ModalDialog
          aria-labelledby="nested-modal-title"
          aria-describedby="nested-modal-description"
          // aria-labelledby="modal-dialog-overflow"
          // layout="fullscreen"
          sx={(theme) => ({
            // pt: '600px',
            // minWidth: { xs: 'unset', md: '800px' },
            [theme.breakpoints.only("xs")]: {
              bottom: 0,
              left: 0,
              right: 0,
              // borderRadius: 0,
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              transform: "none",
              maxWidth: "unset",
              overflow: "auto",
            },
          })}
        >
          <ModalClose
            variant="outlined"
            onClick={() => setRejectModal(false)}
          />
          <DialogTitle>{"Reject partner:" + name}</DialogTitle>
          <DialogContent>Please write a reason for rejection.</DialogContent>
          <Stack
            component={"form"}
            onSubmit={rejectPartner}
            gap={2}
            sx={{ mt: 2 }}
          >
            {/* rejection reason */}
            <FormControl sx={{ flex: 1 }} required>
              <FormLabel>Rejection reason</FormLabel>
              <Input
                type="text"
                value={rejectReason}
                onChange={(e) => setRejectReason(e.target.value)}
                placeholder="Enter rejection reason"
              />
            </FormControl>

            <Button type="submit" fullWidth>
              REJECT
            </Button>
          </Stack>
        </ModalDialog>
      </Modal>

      {/* deactivate modal */}
      <Modal open={deactivateModal}>
        <ModalDialog
          aria-labelledby="nested-modal-title"
          aria-describedby="nested-modal-description"
          // aria-labelledby="modal-dialog-overflow"
          // layout="fullscreen"
          sx={(theme) => ({
            [theme.breakpoints.only("xs")]: {
              bottom: 0,
              left: 0,
              right: 0,
              // borderRadius: 0,
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              transform: "none",
              maxWidth: "unset",
              overflow: "auto",
            },
          })}
        >
          <ModalClose
            variant="outlined"
            onClick={() => setDeactivateModal(false)}
          />
          <DialogTitle>{"Deactivate partner:" + name}</DialogTitle>
          <DialogContent>Please write a reason for deactivation.</DialogContent>
          <Stack
            component={"form"}
            onSubmit={deactivatePartner}
            gap={2}
            sx={{ mt: 2 }}
          >
            {/* rejection reason */}
            <FormControl sx={{ flex: 1 }} required>
              <FormLabel>Deactivate reason</FormLabel>
              <Input
                type="text"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                placeholder="Enter rejection reason"
              />
            </FormControl>

            <Button type="submit" fullWidth>
              DEACTIVATE
            </Button>
          </Stack>
        </ModalDialog>
      </Modal>

      {/* upload photo */}
      <Modal open={uploadPhotoModal}>
        <ModalDialog
          aria-labelledby="nested-modal-title"
          aria-describedby="nested-modal-description"
          sx={(theme) => ({
            [theme.breakpoints.only("xs")]: {
              bottom: 0,
              left: 0,
              right: 0,
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              transform: "none",
              maxWidth: "unset",
              overflow: "auto",
            },
          })}
        >
          <ModalClose
            variant="outlined"
            onClick={() => setUploadModal(false)}
          />
          <DialogTitle>{"Upload Logo for:" + name}</DialogTitle>
          <DialogContent>Upload Photo below.</DialogContent>
          <Stack gap={2} sx={{ mt: 2 }}>
            <UploadPhotoForm id={id} setUploadModal={setUploadModal} />
          </Stack>
        </ModalDialog>
      </Modal>

      {/* approve modal */}
      <Modal open={approvalModal}>
        <ModalDialog
          aria-labelledby="nested-modal-title"
          aria-describedby="nested-modal-description"
          sx={(theme) => ({
            [theme.breakpoints.only("xs")]: {
              bottom: 0,
              left: 0,
              right: 0,
              // borderRadius: 0,
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              transform: "none",
              maxWidth: "unset",
              overflow: "auto",
            },
          })}
        >
          <ModalClose
            variant="outlined"
            onClick={() => setApprovalModal(false)}
          />
          <DialogTitle>{"Approve partner:" + name}</DialogTitle>
          <DialogContent>Please enter the partner FSP code</DialogContent>
          <Stack
            component={"form"}
            onSubmit={approvePartner}
            gap={2}
            sx={{ mt: 2 }}
          >
            {/* rejection reason */}
            <FormControl sx={{ flex: 1 }} required>
              <FormLabel>FSP Code</FormLabel>
              <Input
                type="text"
                value={approvalFspCode}
                onChange={(e) => setApprovalFspCode(e.target.value)}
                placeholder="Enter FSP code"
              />
            </FormControl>

            <Button type="submit" fullWidth>
              APPROVE
            </Button>
          </Stack>
        </ModalDialog>
      </Modal>
    </Box>
  );
};

const mapStateToProps = ({ partner, auth }) => {
  const { otpResult: loginResult } = auth;
  const {
    editPartnerStatus,
    editPartnerResult,
    editPartnerErrorMessage,

    viewPartnerStatus,
    viewPartnerResult,
    viewPartnerErrorMessage,

    rejectPartnerStatus,
    rejectPartnerResult,
    rejectPartnerErrorMessage,

    approvePartnerStatus,
    approvePartnerResult,
    approvePartnerErrorMessage,

    activatePartnerStatus,
    activatePartnerResult,
    activatePartnerErrorMessage,

    deactivatePartnerStatus,
    deactivatePartnerResult,
    deactivatePartnerErrorMessage,
  } = partner;

  return {
    loginResult,

    editPartnerStatus,
    editPartnerResult,
    editPartnerErrorMessage,

    viewPartnerStatus,
    viewPartnerResult,
    viewPartnerErrorMessage,

    rejectPartnerStatus,
    rejectPartnerResult,
    rejectPartnerErrorMessage,

    approvePartnerStatus,
    approvePartnerResult,
    approvePartnerErrorMessage,

    activatePartnerStatus,
    activatePartnerResult,
    activatePartnerErrorMessage,

    deactivatePartnerStatus,
    deactivatePartnerResult,
    deactivatePartnerErrorMessage,
  };
};

export default connect(mapStateToProps, {})(PartnerViewPage);
